/**
 * All actions relating to the EditBreak pages
 */

export const Types = {
    EDIT_BREAK_UNMOUNTED: "EDIT_BREAK_UNMOUNTED",
    REQUEST_BREAK: "REQUEST_BREAK",
    START_DISPLAY_ORDER_SAVE: "START_DISPLAY_ORDER_SAVE",
    END_DISPLAY_ORDER_SAVE: "END_DISPLAY_ORDER_SAVE",
    START_RENAME_STEP: "START_RENAME_STEP",
    END_RENAME_STEP: "END_RENAME_STEP",
    GET_BREAK_IMAGES_PAGE: "GET_BREAK_IMAGES_PAGE",
    GET_ALL_BREAK_IMAGES: "GET_ALL_BREAK_IMAGES",
    RECEIVED_ALL_BREAK_IMAGES: "RECEIVED_ALL_BREAK_IMAGES",
    SET_BREAK_PALETTE: "SET_BREAK_PALETTE",
    SAVE_PALETTE: "SAVE_PALETTE",
    ERROR_CREATING_PALETTE: "ERROR_CREATING_PALETTE",
    SUCCESS_CREATING_PALETTE: "SUCCESS_CREATING_PALETTE",
    SEARCH_BREAK_TAGS: "SEARCH_BREAK_TAGS",
    RECEIVED_BREAK_TAGS: "RECEIVED_BREAK_TAGS",
    CREATE_ADD_BREAK_TAG: "CREATE_ADD_BREAK_TAG",
    REMOVE_BREAK_TAG: "REMOVE_BREAK_TAG",
    ADD_BREAK_TAG: "ADD_BREAK_TAG",
    END_EDIT_BREAK_TAGS: "END_EDIT_BREAK_TAGS",
    BREAK_TAG_ADDED: "BREAK_TAG_ADDED",
    REMOVE_BREAK_SITE_TAG: "REMOVE_BREAK_SITE_TAG",
    ADD_BREAK_SITE_TAG: "ADD_BREAK_SITE_TAG",
    BREAK_SITE_TAG_ADDED: "BREAK_SITE_TAG_ADDED",
};

export const requestBreakAction = (challengeId, params) => ({
  type: Types.REQUEST_BREAK,
  challengeId: challengeId,
  params: params
});

export const receivedBreak = ( breaksObj ) => {
  return { type: 'RECEIVED_BREAK', breaks: breaksObj };
};

export const unmountBreak = () => {
  return { type: 'EDIT_BREAK_UNMOUNTED' };
};

export const persistValueAction = (field, value, url, additionalData) => {
  return {
    type: "PERSIST_VALUE",
      field: field,
      value: value,
      url: url,
      additionalData: additionalData
  };
};

export const valuePersistedAction = (obj) => {
  return {
    type: "VALUE_PERSISTED",
      obj: obj
  };
};

export const startDisplayOrderSaveAction = (
    masterResourceId,
    stepResourceId,
    displayOrdersAndResourceIds // [{displayOrder, resourceId}]
) => ({
    type: Types.START_DISPLAY_ORDER_SAVE,
    masterResourceId,
    stepResourceId,
    displayOrdersAndResourceIds
});

export const endDisplayOrderSaveAction = () => ({
    type: Types.END_DISPLAY_ORDER_SAVE
});

export const startRenameStepAction = (step, index) => ({
    type: Types.START_RENAME_STEP,
    step,
    index
});

export const endRenameStepAction = () => ({
    type: Types.END_RENAME_STEP
});

export const getBreakImagesPageAction = (count, page, breakId) => ({
    type: Types.GET_BREAK_IMAGES_PAGE,
    count: count,
    page: page,
    breakId: breakId
});

export const getAllBreakImagesAction = breakId => ({
    type: Types.GET_ALL_BREAK_IMAGES,
    breakId
});

export const receivedAllBreakImagesAction = images => ({
    type: Types.RECEIVED_ALL_BREAK_IMAGES,
    images
});

export const setBreakPaletteAction = (breakId,palette) => ({
    type: Types.SET_BREAK_PALETTE,
    palette: palette,
    breakId: breakId
});

export const savePaletteAction = (breakId, newPaletteName) => ({
  type: Types.SAVE_PALETTE,
  breakId: breakId,
  newPaletteName: newPaletteName
});

export const errorCreatingPaletteAction = (error) => ({
  type: Types.ERROR_CREATING_PALETTE,
  formError: error
});

export const successCreatingPaletteAction = () => ({
    type: Types.SUCCESS_CREATING_PALETTE
});

export const searchBreakTagsAction = (searchText) => ({
    type: Types.SEARCH_BREAK_TAGS,
    searchText
});

export const receivedBreakTagsAction = (tags) => ({
    type: Types.RECEIVED_BREAK_TAGS,
    tags
});

export const createAddBreakTagAction = () => ({
    type: Types.CREATE_ADD_BREAK_TAG
});

export const removeBreakTagAction = (tagId) => ({
    type: Types.REMOVE_BREAK_TAG,
    tagId
});

export const addBreakTagAction = (tagIds) => ({
    type: Types.ADD_BREAK_TAG,
    tagIds
});

export const breakTagAddedAction = () => ({
    type: Types.BREAK_TAG_ADDED
});

export const removeBreakSiteTagAction = (label) => ({
  type: Types.REMOVE_BREAK_SITE_TAG,
  label
});

export const addBreakSiteTagAction = (labels) => ({
  type: Types.ADD_BREAK_SITE_TAG,
  labels
});

export const breakSiteTagAddedAction = () => ({
  type: Types.BREAK_SITE_TAG_ADDED
});



// WEBPACK FOOTER //
// ./public/pages/EditBreak/actions.js